import _ from 'lodash';
import supportedActions from './supportedSimpleActionsList';
export default class SimpleActionsSelect {
    static load(filterOnProperty) {
        return {
            label: 'Action',
            description: 'Select Actions',
            key: 'action',
            type: 'select',
            multi: false,
            validate: {
                required: true
            },
            dataSrc: 'custom',
            refreshOn: filterOnProperty,
            valueProperty: 'value',
            clearOnRefresh: true,
            data: {
                custom: ({ data }) => {
                    const equipmentTypeOptions = _.get(supportedActions, _.get(data, [filterOnProperty, 'equipmentType']));
                    const fetchedDynamicOptions = _.transform(equipmentTypeOptions?.dynamicOptions, (memo, option) => {
                        memo[option.property] = _.get(data, option.path);
                    }, {});
                    return _.map(equipmentTypeOptions?.options, (option) => {
                        _.assign(option.value.body, fetchedDynamicOptions);
                        return option;
                    });
                }
            }
        };
    }
}
